import {executePost} from "../Api";
import moment from "moment";
import {getDeviceId} from "../utils/deviceId";
import {captureError, detectInAppBrowser, addBreadcrumb} from "../utils";

export class ManualPayment {

    timeout = null;
    data;
    token = null;
    ssl_transaction_type;

    resolve;
    reject;

    frontEndGatewayResponse = {};
    nmiInitialized = false;
    validationErrors = [];
    _paymentSubmitted = false;

    constructor(data, handleSubmit) {
        this.data = data;
        this.paymentGatewayType = data?.adminUser?.paymentGateways?.type;
        this.handleSubmit = handleSubmit;
    }

    handleSubmit = () => {
    };

    // Method to check validation errors and display them
    checkValidationErrors() {
        const errorFields = Object.keys(this.validationErrors);
        if (errorFields.length > 0) {
            const firstError = this.validationErrors[errorFields[0]];
            return {
                hasErrors: true,
                error: {
                    message: firstError.message,
                    errorMessage: firstError.detailMessage
                }
            };
        }
        return { hasErrors: false };
    }

    async init() {
        if (this.paymentGatewayType === 'NMI') {
            return await this.initNmi({paymentGateways: this.data.adminUser.paymentGateways});
        }
    }

    initTransactionType() {
        if (this.data.isEcheck) {
            const isAddPaymentMethod = this.data.amount == 0 || (this.data.isPaymentSaveDetails && this.data.amount > 0);
            if (isAddPaymentMethod) {
                this.ssl_transaction_type = "ecsaddrecurring";
                this.ssl_next_payment_date = moment().add(1, 'Y').format("MM/DD/YYYY");
                this.ssl_billing_cycle = "SUSPENDED";
            } else {
                this.ssl_transaction_type = "ecspurchase";
            }
        } else {
            if (this.data.amount == 0 || this.data.amount == 0.01) {
                this.ssl_transaction_type = "ccauthonly"
            } else {
                this.ssl_transaction_type = "ccsale"
            }
        }
    }

    pay(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        return new Promise(async (resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
            this._paymentSubmitted = false;

            // Check for validation errors before proceeding
            const errorFields = Object.keys(this.validationErrors);
            if (errorFields.length > 0) {
                const firstError = this.validationErrors[errorFields[0]];
                const validationError = new Error(firstError.message);
                validationError.errorMessage = firstError.detailMessage;
                validationError.errorType = 'validation';
                this.reject(validationError);
                return;
            }

            if (this.paymentGatewayType === 'NMI') {
                const isNewCardEntry = !this.data?.paymentMethodId;
                const isSwipe = this.data?.paymentMethod?.paymentType === 'swipe';
                if (isNewCardEntry && !isSwipe && !this.frontEndGatewayResponse?.token) {
                    const reason = !this.nmiInitialized
                        ? 'Payment fields are still loading. Please wait a moment and try again.'
                        : 'Payment token was not generated. Please reload the page and try again.';
                    const tokenError = new Error(reason);
                    tokenError.errorType = 'validation';
                    captureError(tokenError, {
                        errorType: 'missing_payment_token',
                        context: {
                            hasResponse: !!this.frontEndGatewayResponse,
                            responseKeys: Object.keys(this.frontEndGatewayResponse || {}).join(','),
                            nmiInitialized: this.nmiInitialized,
                            subdomain: this.data?.subdomain,
                        },
                    });
                    this.reject(tokenError);
                    return;
                }
                await this.nmiTransaction();
            }
            if (this.paymentGatewayType === 'converge') {
                if (this.data.isEcheck && this.data.ssl_recurring_id) {
                    const result = await this.chargeECheckPaymentMethod(this.data.ssl_recurring_id);
                    this.resolve(result);
                } else {
                    this.initTransactionType();
                    this.token = await this.retrieveToken();
                    await this.sendToConverge();
                }
            }
        });
    }

    retrieveToken() {
        return executePost("payments/token", {
            ssl_amount: this.getAmount(),
            subdomain: this.data.subdomain,
            ssl_transaction_type: this.ssl_transaction_type,
        }).then((res) => {
            const {data} = res || {};
            return data?.data;
        }).catch((err) => {
            console.log("err pwo3zqvb", err);
            return err;
        });
    }

    chargeECheckPaymentMethod(ssl_recurring_id) {
        return executePost("transaction/updateAndChargeECheck", {
            adminUser: this.data.adminUser,
            payerUser: this.data.payerUser,
            paymentMethod: {
                isDefault: this.data.isDefault,
                paymentType: "eCheck"
            },
            patientPayer: this.data.patientPayer,
            ...this.serializeDataForConverge(),
            ssl_recurring_id: ssl_recurring_id,
            bankName: this.data.bankName
        });
    }

    getAmount() {
        // return +this.data.amount === 0 ? "0.01" : this.data.amount;
        let ssl_amount = +this.data.amount === 0 ? "0.01" : this.data.amount;
        if (typeof ssl_amount === 'number') {
            ssl_amount = ssl_amount.toString();
        }
        if (typeof ssl_amount !== 'string') {
            ssl_amount = "0.01";
        }
        ssl_amount = ssl_amount.replaceAll(',', '');
        console.log("ssl_amount", ssl_amount);
        return ssl_amount;

    }

    serializeDataForConverge() {

        let request;
        if (this.data.isEcheck) {
            // case 1:
            // User wants to make a payment but not add eCheck
            // -- front end does ssl_transaction_type = "ecspurchase"

            //case 2:
            // User wants to add eCheck as a payment method but make no payment
            // -- front end does ssl_transaction_type = "ecsaddrecurring"

            // case 3 = case 2 + case 4:
            // User wants to make a payment AND add eCheck
            // -- front end does ecsaddrecurring

            // -- back end does ecsupdaterecurring and then ecsrecurringsale

            // case 4:
            // User wants to make a payment using an eCheck payment method that's already saved
            // -- back end does ecsupdaterecurring and then ecsrecurringsale
            // this is already in the back end, in converge.js

            /*
            ssl_company: companyName,
             */


            // ssl_amount: isAddPaymentMethod ? "0.01" : this.getAmount(),
            request = {
                ssl_amount: this.getAmount(),
                ssl_bank_account_type: this.data.bankAccountType,
                ssl_transaction_type: this.ssl_transaction_type,
                ssl_next_payment_date: this.ssl_next_payment_date,
                ssl_billing_cycle: this.ssl_billing_cycle,
                ssl_txn_auth_token: this.token,
                ssl_first_name: this.data.firstName,
                ssl_last_name: this.data.lastName,
                ssl_company: this.data.companyName,
                ssl_email: this.data.payerEmail,
                ssl_aba_number: this.data.bankRoutingNumber,
                ssl_bank_account_number: this.data.bankAccountNumber,
                ssl_agree: "1",
                ssl_recurring_id: this.data.ssl_recurring_id
            };
        } else {
            request = {
                ssl_amount: this.getAmount(),
                ssl_transaction_type: this.ssl_transaction_type,
                ssl_txn_auth_token: this.token,
                ssl_exp_date: this.data.expirationDate,
                ssl_cvv2cvc2: this.data.cvv,
                ssl_card_number: this.data.cardNumber && this.data.cardNumber.replace(' ', ''),
                ssl_first_name: this.data.firstName,
                ssl_last_name: this.data.lastName,
                ssl_email: this.data.payerEmail,
                ssl_get_token: "Y",
                ssl_add_token: "Y",
            };
        }
        if (!this.data.cvv && this.data.ssl_token) {
            request.ssl_token = this.data.ssl_token;
        }
        return request;
    }

    async sendToConverge() {
        const callback = {
            onError: (error) => {
                console.error(error);
                this.reject(error);

            }, onDeclined: (response) => {
                console.error(response);
                this.reject(response);
            },
            onDCCDecision: () => {
                window.ConvergeEmbeddedPayment.dccDecision({dccOption: false}, callback);
            }, onApproval: async (response) => {
                try {
                    //we must get rid of these!
                    const ssl_card_number = response?.ssl_card_number?.substr(-4) || "";
                    const transactionId = response?.ssl_txn_id || ""
                    const ssl_card_short_description = response?.ssl_card_short_description || "";
                    const ssl_token = response?.ssl_token || "";
                    if (this.data.isEcheck && this.data.isPaymentSaveDetails && this.data.amount > 0.01) {
                        const ssl_recurring_id = response?.ssl_recurring_id || "";
                        const result = await this.chargeECheckPaymentMethod(ssl_recurring_id);
                        this.resolve(result);
                    } else {
                        this.resolve({
                            ssl_card_number,
                            transactionId,
                            ssl_token,
                            ssl_card_short_description,
                            response,
                            bankName: this.data.bankName,
                            ...response,
                            // data: this.data
                        });
                    }


                } catch (err) {
                    console.error(err);
                    this.reject(err);
                }
            },
        };
        await window.ConvergeEmbeddedPayment.pay(this.serializeDataForConverge(), callback);
    }

    async nmiTransaction() {

        const submitData = {
            paymentMethod: {
                paymentType: this.data.isEcheck ? 'eCheck' : 'creditCard',
                isDefault: this.data.isDefault || false
            },
            frontEndGatewayResponse: this.frontEndGatewayResponse,
            ...this.data,
            amount: this.getAmount(),
            subdomain: this.data.subdomain,
            deviceId: getDeviceId(),
            // ssl_transaction_type: this.ssl_transaction_type, // ???? credit card vs. ....? check, swipe....?
        };

        addBreadcrumb({
            category: 'payment.zip',
            message: 'nmiTransaction submitData',
            level: 'info',
            data: {
                zipInData: this.data.zip || '(empty)',
                zipInSubmitData: submitData.zip || '(empty)',
                hasToken: !!this.frontEndGatewayResponse?.token,
                hasWallet: !!this.frontEndGatewayResponse?.wallet,
                walletKeys: Object.keys(this.frontEndGatewayResponse?.wallet || {}).join(',') || '(none)',
            },
        });

        return executePost("transaction/nmiTxn", submitData).then((res) => {
            const {data} = res || {};
            // return data?.data;

            this.resolve(data);
            // if(data?.data) {
            //     this.resolve(data?.data);
            // }
            // this.resolve({
            //     ssl_card_number,
            //     transactionId,
            //     ssl_token,
            //     ssl_card_short_description,
            //     response,
            //     bankName: this.data.bankName,
            //     ...response,
            //     // data: this.data
            // });
        }).catch((err) => {
            console.log("err dn2k3j2j", err);
            console.error(err);
            this.reject(err);
        });
    }

    // async initNmi({paymentGateways, formSelectors}) {
    async initNmi({paymentGateways}) {
        return new Promise(async (resolve, reject) => {
            // If already initialized, return early to prevent duplicate callbacks
            if (this.nmiInitialized) {
                resolve("Already initialized");
                return;
            }

            // Check if CollectJS is already loaded
            if (window.CollectJS) {
                this._configureCollectJS();
                this.nmiInitialized = true;
                resolve("Script already loaded");
                return;
            }

            // Check if script tag already exists in the document
            const existingScript = document.querySelector(`script[data-tokenization-key="${paymentGateways?.tokenizationKey}"]`);
            if (existingScript) {
                // Script is loading or loaded, wait for window.CollectJS to be available (max 10s)
                let pollCount = 0;
                const checkCollectJS = setInterval(() => {
                    pollCount++;
                    if (window.CollectJS) {
                        clearInterval(checkCollectJS);
                        this._configureCollectJS();
                        this.nmiInitialized = true;
                        resolve("Script already loading");
                    }
                    if (pollCount > 100) {
                        clearInterval(checkCollectJS);
                        const err = new Error('Payment gateway script never became available');
                        captureError(err, { errorType: 'Payment Gateway Error', context: 'CollectJS polling timeout after 10s' });
                        reject(err);
                    }
                }, 100);
                return;
            }

            // Script doesn't exist — load with retry (up to 3 attempts)
            const maxRetries = 3;
            const loadScript = (attempt) => {
                // Remove failed script tag from previous attempt
                const oldScript = document.querySelector(`script[src="${paymentGateways?.src}"]`);
                if (oldScript) oldScript.remove();

                const script = document.createElement("script");
                script.src = paymentGateways?.src;
                script.setAttribute("data-tokenization-key", paymentGateways?.tokenizationKey);
                script.async = true;

                console.log(`[NMI] Loading script (attempt ${attempt}/${maxRetries}): ${paymentGateways?.src}`);

                script.onload = () => {
                    this._configureCollectJS();
                    this.nmiInitialized = true;
                    resolve("Script loaded");
                };
                script.onerror = () => {
                    console.error(`[NMI] Script failed to load (attempt ${attempt}/${maxRetries})`);
                    if (attempt < maxRetries) {
                        setTimeout(() => loadScript(attempt + 1), 1000 * attempt);
                    } else {
                        const inAppCheck = detectInAppBrowser();
                        let loadErr;
                        if (inAppCheck.inApp) {
                            loadErr = new Error(`You opened this page from ${inAppCheck.app}. In-app browsers may block payments. Please open this page in your default browser.`);
                            loadErr.errorType = 'IN_APP_BROWSER';
                        } else {
                            loadErr = new Error(`Payment gateway script failed to load after ${maxRetries} attempts: ${script.src}`);
                        }
                        captureError(loadErr, {
                            errorType: 'Payment Gateway Error',
                            context: 'Payment script load failed after all retries',
                            attempts: maxRetries,
                        });
                        reject(loadErr);
                    }
                };
                document.body.appendChild(script);
            };
            loadScript(1);
        });
    }

    destroy() {
        if (this._unhandledRejectionHandler) {
            window.removeEventListener('unhandledrejection', this._unhandledRejectionHandler);
            this._unhandledRejectionHandler = null;
        }
    }

    _configureCollectJS() {
        // Listen for unhandled rejections from the payment gateway SDK (e.g. 404 from /token/api/lookup)
        // The SDK throws AxiosErrors internally without catching them
        this._unhandledRejectionHandler = (event) => {
            const err = event.reason;
            const isGatewaySDKError = err?.config?.url && /token\/api/i.test(err.config.url);
            if (isGatewaySDKError) {
                event.preventDefault();
                // Once payment has been submitted to our backend, ignore SDK internal errors
                // (the SDK does a second token/api/lookup after the token is consumed, which 404s)
                if (this._paymentSubmitted) {
                    return;
                }
                if (this.reject) {
                    const status = err.response?.status;
                    // 404 on token/api/lookup means the NMI token expired (user waited too long)
                    const isTokenExpired = status === 404 && /lookup/i.test(err.config?.url);
                    const message = isTokenExpired
                        ? 'Your payment session has expired. Please reload the page and try again.'
                        : 'Payment processing failed. Please try again or use a different payment method.';
                    const sdkError = new Error(message);
                    sdkError.errorType = isTokenExpired ? 'token_expired' : 'gateway_sdk';
                    captureError(sdkError, {
                        errorType: 'collectjs_sdk_error',
                        context: {
                            url: err.config?.url,
                            status,
                            message: err.message,
                            isTokenExpired,
                        },
                    });
                    this.reject(sdkError);
                }
            }
        };
        window.addEventListener('unhandledrejection', this._unhandledRejectionHandler);

        window.CollectJS.configure({
            paymentSelector: "#submitPayButton",
            timeoutDuration: 15000,
            timeoutCallback: (() => {
                if (this.reject) {
                    const err = new Error('Payment processing timed out. Please try again.');
                    err.errorType = 'gateway_sdk';
                    this.reject(err);
                }
            }).bind(this),
            fields: {
                ccnumber: {
                    selector: "#ccNumberInput",
                    title: "Card Number",
                    placeholder: "0000 0000 0000 0000",
                },
                ccexp: {
                    selector: "#ccExpInput",
                    title: "Card Expiration",
                    placeholder: "00 / 00",
                },
                cvv: {
                    display: "show",
                    selector: "#cvvInput",
                    title: "CVV Code",
                    placeholder: "***",
                },
            },
            currency: "USD",
            country: "US",
            variant: "inline",
            validationCallback: ((field, status, message) => {
                console.log('CollectJS validation callback:', { field, status, message });
                if (status === false) {
                    console.error(`Validation failed for ${field}: ${message}`);
                    const fieldName = field === 'ccnumber' ? 'card number' : field === 'ccexp' ? 'expiration date' : 'CVV code';
                    const validationError = {
                        field,
                        fieldName,
                        message: `Please enter a valid ${fieldName}`,
                        detailMessage: `The ${fieldName} entered was invalid: ${message}`
                    };
                    this.validationErrors[field] = validationError;
                } else {
                    delete this.validationErrors[field];
                }
            }).bind(this),
            callback: async (response) => {
                try {
                    console.log("CollectJS response:", response);
                    if (!response || !response.token) {
                        console.error('CollectJS validation failed: No payment token received');
                        const validationError = new Error('Please enter valid credit card information');
                        validationError.errorMessage = 'Credit card information entered was missing or inaccurate';
                        validationError.errorType = 'validation';
                        this.reject(validationError);
                        return;
                    }
                    this.frontEndGatewayResponse = response;
                    this._paymentSubmitted = true;
                    addBreadcrumb({
                        category: 'payment.zip',
                        message: 'CollectJS callback - about to call handleSubmit',
                        level: 'info',
                        data: {
                            hasToken: !!response?.token,
                            responseKeys: Object.keys(response || {}).join(','),
                            hasWallet: !!response?.wallet,
                            walletBillingZip: response?.wallet?.billingInfo?.zip || '(none)',
                            dataZipAtCallback: this.data?.zip || '(not set yet)',
                        },
                    });
                    this.handleSubmit(undefined, true);
                } catch (err) {
                    alert(`Error ${err.message}\n ${JSON.stringify(err)}`)
                    console.error('CollectJS callback error #nsjdk2j32 ', err);
                }
            }
        });
    }

}
